// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import { Row, Col, SchemaTable } from "@components";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";

type OwnProps = $Exact<{
  data: ?EmailNotification,
  schema: Object,
  editing?: boolean,
  onChange?: (data: Object) => void,
  onSubmit?: (data: Object) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

type OwnState = $Exact<{
  formData: EmailNotification | Object,
}>;

type DefaultInstruction = $Exact<{
  id: string,
  reason: string,
  instructionText: string,
}>;

export class EmailNotificationDefaultInstructions extends React.Component<Props, OwnState> {
  state = {
    formData: {},
  };

  componentDidMount() {
    if (this.props.data) {
      this.setState({ formData: this.props.data });
    }
  }

  get data(): Array<DefaultInstruction> {
    const data = this.props.editing ? this.state.formData : this.props.data;
    const schemaProps = (this.props.schema || {}).properties;

    return [
      {
        id: "updateNotification",
        reason: schemaProps.updateNotification.title,
        instructionText: data.updateNotification,
      },
      {
        id: "closedInstruction",
        reason: schemaProps.closedInstruction.title,
        instructionText: data.closedInstruction,
      },
      {
        id: "overdueInstruction",
        reason: schemaProps.overdueInstruction.title,
        instructionText: data.overdueInstruction,
      },
    ];
  }

  handleChange = (data: Array<Object>) => {
    const _data = { ...this.props.data };

    for (var item of data) {
      _data[item.id] = item.instructionText || "";
    }

    if (this.props.onChange) {
      this.setState({ formData: _data });
      this.props.onChange(_data);
    }
  };

  get schema() {
    return {
      type: "object",
      properties: {
        reason: {
          type: "string",
        },
        instructionText: {
          type: "string",
        },
      },
    };
  }

  get uiSchema() {
    let uiSchema = {
      reason: {
        "ui:title": null,
        "ui:widget": "text",
        "ui:options": {
          minWidth: "14%",
          editable: false,
        },
      },
      instructionText: {
        "ui:title": null,
        "ui:header": this.props.t("INSTRUCTIONS"),
        "ui:widget": "textarea",
        "ui:options": {
          minWidth: "85%",
          editable: Boolean(this.props.editing),
          maxLength: 2000,
        },
      },
    };

    return uiSchema;
  }

  render() {
    return (
      <React.Fragment>
        <div className="record-table">
          <SchemaTable
            tableData={this.data}
            schema={this.schema}
            uiSchema={this.uiSchema}
            onChange={this.handleChange}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default localize()(EmailNotificationDefaultInstructions);
